import { Component, OnInit } from '@angular/core';
import { EmployeeDepositsService } from '../service/employee-deposits.service'
import { NgForm } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { UserService } from '../shared/user.service';
import { FeedbackService } from '../service/feedback.service';


@Component({
  selector: 'app-employee-deposits',
  templateUrl: './employee-deposits.component.html',
  styleUrls: ['./employee-deposits.component.css']
})
export class EmployeeDepositsComponent implements OnInit {
  fileEmpId: any = null;
  arrEmp: any = [];
  resultQuery: any[];
  resultTable: any[] = null;
  cols: any[];
  arrFrom: any[] = [];
  selectedFrom: any = null
  arrTo: any[] = [];
  selectedTo: any = null
  ddlStatusDescription: any[] = [];
  selectedStatus: any = null;
  FileEmployeeId: any;
  msgs: any[] = [];
  userDetails: any;
  listcustomer: any[] = [];
  selectedCustomerId: any = null;
  listFundInstitutions: any[] = [];
  selectedFundInstitutionId: any = null;
  listEmp: any[] = [];
  selectedEmpId: any = null;
  asyncCallsCounter: any = 0;
  ReportType: any = "regular";
  showFeedbackErrorCodeDescription: any = false;
  FeedbackError: any = null;
  dateType: any = '1';
  includeFurlough: boolean = false;

  constructor(private dataService: EmployeeDepositsService, private router: Router, private userService: UserService, private feedbackService: FeedbackService) { }

  ngOnInit() {
    this.asyncCallsCounter++;
    this.userService.getUserClaims().subscribe((result: any) => {
      this.asyncCallsCounter--;
      this.userDetails = result;
      if (this.userDetails && (this.userDetails.ClientRoleSupport || this.userDetails.ClientRoleAdministration || this.userDetails.ClientRoleSemiAdministrator)) {
        this.dataService.getCustomers().subscribe((result: any) => {
          this.listcustomer = result;
          this.listcustomer.unshift({ label: 'בחר מעסיק', value: null });
        },
          (err: HttpErrorResponse) => {
            this.showMessage('error', '', 'תקלה בקבלת רשימת מעסיקים');
          });
      }
      else {
        //this.getDate();
        //this.fundInstitutionSelected();
        this.selectedCustomerId = this.userDetails.CurrentCustomerIdentityNumber;
        this.funOnChange();
      }
    },
      (err: HttpErrorResponse) => {
        this.asyncCallsCounter--;
        this.userDetails = null;
      });

    this.asyncCallsCounter++;
    this.dataService.getFeedbackStatusDDL().subscribe((result: any) => {
      this.asyncCallsCounter--;
      this.ddlStatusDescription = result;
      this.ddlStatusDescription.unshift({ label: 'הכל', value: null });
    },
      (err: HttpErrorResponse) => {
        //this.router.navigate(['error-page/', err.error.ExceptionMessage])
        this.asyncCallsCounter--;
        this.showMessage('error', '', 'תקלה בקבלת סטטוסים');
      });

    this.cols = [
      { field: 'FullName', header: 'עובד' },
      { field: 'MISPAR_MEZAHE_OVED', header: 'ת. ז.' },
      { field: 'CHODESH_MASKORET', header: 'חודש שכר' },
      { field: 'ReportMonth', header: 'חודש דיווח' },
      { field: 'KupaName', header: 'סוג קופה' },
      { field: 'InstitutionName', header: 'שם קופה' },
      { field: 'SUG_HAFRASHA', header: 'סוג הפרשה' },
      { field: 'SCHUM_HAFRASHA', header: 'סכום' },
      { field: 'StatusDepositTreatmentDescription', header: 'סטטוס רשומה' },
      { field: 'ErrorCodeV4Id', header: 'קוד שגיאה' }
    ];
  }

  getDate(): any {
    if (this.selectedCustomerId != null || this.selectedCustomerId != undefined) {
      this.asyncCallsCounter++;
      this.dataService.getDate(this.selectedCustomerId).subscribe((result: any) => {
        this.asyncCallsCounter--;
        this.arrFrom = result;
        this.arrTo = result;
        if (this.arrFrom.length >= 12) {
          this.selectedFrom = this.arrFrom[this.arrTo.length - 12];
        }
        else {
          this.selectedFrom = this.arrFrom[0];
        }

        this.selectedTo = this.arrTo[this.arrTo.length - 1];
      }, (err: HttpErrorResponse) => {
        this.asyncCallsCounter--;
        this.showMessage('error', '', 'תקלה בקבלת תאריכים');
      });
    }
  }

  getEmp() {
    if (this.selectedCustomerId != null || this.selectedCustomerId != undefined) {
      this.asyncCallsCounter++;
      this.dataService.getEmp(this.selectedCustomerId).subscribe((result: any) => {
        this.asyncCallsCounter--;
        this.listEmp = result;
        this.listEmp.unshift({ label: 'הכל', value: null });
      },
        (err: HttpErrorResponse) => {
          //this.router.navigate(['error-page/', err.error.ExceptionMessage])
          this.asyncCallsCounter--;
          this.showMessage('error', '', 'תקלה בקבלת נתונים עבור העובד שהוזן');
        });
    } else {
      this.showMessage('error', '', 'חייב להזין מעסיק');
    }
  }




  getReport(empDeposit: NgForm): void {
    if (empDeposit.valid) {
      this.selectedStatus = this.selectedStatus == null ? "" : this.selectedStatus;
      this.selectedFrom = this.selectedFrom == null ? "" : this.selectedFrom;
      this.selectedTo = this.selectedTo == null ? "" : this.selectedTo;
      this.selectedFundInstitutionId = this.selectedFundInstitutionId == null ? "" : this.selectedFundInstitutionId;
      this.selectedEmpId = this.selectedEmpId == null ? "" : this.selectedEmpId;
      this.asyncCallsCounter++;
      this.dataService.getReport(this.selectedFrom, this.selectedTo, this.selectedEmpId, this.selectedStatus, this.selectedCustomerId, this.selectedFundInstitutionId, this.ReportType, this.dateType, this.includeFurlough).subscribe((result: any) => {
        this.asyncCallsCounter--;
        this.resultTable = result;
      }, (err: HttpErrorResponse) => {
        this.asyncCallsCounter--;
        this.showMessage('error', '', 'קיימת תקלה בהצגת הדוח');
      });
    }
  }

  fundInstitutionSelected(): any {
    if (this.selectedCustomerId != null || this.selectedCustomerId != undefined) {
      this.asyncCallsCounter++;
      this.dataService.getFundInstitution(this.selectedCustomerId).subscribe((result: any) => {
        this.asyncCallsCounter--;
        this.listFundInstitutions = result;
        this.listFundInstitutions.unshift({ label: 'הכל', value: null });
      },
        (err: HttpErrorResponse) => {
          this.asyncCallsCounter--;
          this.showMessage('error', '', 'תקלה בקבלת רשימת קופות לעובד');
        });
    }
  }
  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }
  funOnChange(): void {
    this.getDate();
    this.fundInstitutionSelected();
    this.getEmp();
  }

  getFeedbackErrorCodeDescription(rowdata):void{
    this.FeedbackError = rowdata.ErrorCodeV4Description;
    this.showFeedbackErrorCodeDescription = true;
  }

  FeedbackErrorCodeDescriptionClosed(): void {
    this.FeedbackError = null;
    this.showFeedbackErrorCodeDescription = false;
  }


}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/employee-deposits/employee-deposits.component.ts